import { ToastMessage } from 'primereact/toast';

export const createToastMessage = (severity: 'success' | 'info' | 'warn' | 'error', summary: string, detail: string): ToastMessage => ({
    severity,
    summary,
    detail,
    life: 3000,
    contentClassName: severity === 'error' ? 'error-toast' : 'success-toast'
});